module.exports = __webpack_public_path__ + "img/radiation.0e965e16.png";